export default "/images/vendor/flag-icons/flags/1x1/th.svg?b4262644824a028810ca42e7d45fe161";